// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".glossar-overlay[data-v-d464041e]{z-index:99}", ""]);
// Exports
module.exports = exports;
